import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUser, LoggedInUserService } from '../../../auth/logged.in.user';
import { CmsDialogDto } from '../../../models/cms.dialogs/cms.dialogs.models';
import { CmsDialogService } from '../../../services/cms.dialog.service';

type HelpTenderAlertsProfileTab = 'profile' | 'extraAlerts';

@Component({
    selector: 'help-tender-alerts-profile',
    template: require('./help.tender-alerts-profile.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.tender-alerts-profile.component.css')]
})
export class HelpTenderAlertsProfileComponent implements OnInit, OnDestroy {
    private readonly tabOrder: HelpTenderAlertsProfileTab[] = ['profile', 'extraAlerts'];
    private readonly dialogPrefixes: Record<HelpTenderAlertsProfileTab, string> = {
        profile: 'Alert Profile Info',
        extraAlerts: 'Extra Alerts List'
    };

    selectedTabIndex = 0;
    profileContent = '';
    extraAlertsContent = '';

    private subscribed: boolean;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly cmsDialogService: CmsDialogService,
        userService: LoggedInUserService) {
        this.subscribed = !userService.getCurrentUser().canAdHoc('notSubscribed');
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        this.route.queryParams.subscribe(params => {
            const tab = this.normalizeTab((params && params.tab ? params.tab : '').toString());
            this.selectedTabIndex = this.tabOrder.indexOf(tab);
            if (this.selectedTabIndex < 0) {
                this.selectedTabIndex = 0;
            }
        });

        this.loadDialogTab('profile', 'profileContent');
        this.loadDialogTab('extraAlerts', 'extraAlertsContent');
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }

    onTabChange(index: number) {
        const tab = this.tabOrder[index] || 'profile';
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    private normalizeTab(tab: string): HelpTenderAlertsProfileTab {
        if (tab === 'profile' || tab === 'extraAlerts') {
            return tab;
        }
        return 'profile';
    }

    private loadDialogTab(
        tab: HelpTenderAlertsProfileTab,
        contentField: 'profileContent' | 'extraAlertsContent') {
        const suffix = this.subscribed ? 'Subscribed' : 'Not Subscribed';
        const description = `${this.dialogPrefixes[tab]} - ${suffix}`;

        this.cmsDialogService.getByDescription(description).subscribe((result: CmsDialogDto) => {
            this[contentField] = result.body || '';
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.tender-alerts-profile.component.ts